import { combineReducers } from 'redux';
import types from './types';

export interface IPaySimpleError {
  hasFailed: boolean;
  message: string;
}

const INITIAL_IS_PENDING = false;
const INITIAL_ERROR: IPaySimpleError = {
  hasFailed: false,
  message: ''
};

const JwtToken = (
  state: any = {},
  { type, payload }: { type: string; payload: string }
) => {
  switch (type) {
    case types.SET_PAYSIMPLE_CHECKOUT_TOKEN:
      return payload;
    default:
      return state;
  }
};

const Expiration = (
  state: any = {},
  { type, payload }: { type: string; payload: string }
) => {
  switch (type) {
    case types.SET_PAYSIMPLE_CHECKOUT_EXPIRATION:
      return payload;
    default:
      return state;
  }
};

const url = (
  state: any = {},
  { type, payload }: { type: string; payload: string }
) => {
  switch (type) {
    case types.SET_PAYSIMPLE_CHECKOUT_URL:
      return payload;
    default:
      return state;
  }
};

const isPending = (
  state: boolean = INITIAL_IS_PENDING,
  { type, payload }: { type: string; payload: any }
) => {
  switch (type) {
    case types.SET_PAYSIMPLE_CHECKOUT_IS_PENDING:
      return payload;

    default:
      return state;
  }
};

const error = (
  state: IPaySimpleError = INITIAL_ERROR,
  { type, payload }: { type: string; payload: any }
) => {
  switch (type) {
    case types.SET_PAYSIMPLE_CHECKOUT_ERROR:
      return payload;
    default:
      return state;
  }
};

const paySimpleReducer = combineReducers({
  JwtToken,
  Expiration,
  url,
  isPending,
  error
});

export default paySimpleReducer;
